import { render, staticRenderFns } from "./NavBarForRights.vue?vue&type=template&id=90968b7a&scoped=true&"
import script from "./NavBarForRights.vue?vue&type=script&lang=js&"
export * from "./NavBarForRights.vue?vue&type=script&lang=js&"
import style0 from "./NavBarForRights.vue?vue&type=style&index=0&id=90968b7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90968b7a",
  null
  
)

export default component.exports